import api from './api'

const fetchMediaByTerm = (term) => api.get(`/api/tags/media/search/${term}?size=15&from=0&typeahead=y`)
const getAllTags = () => api.get(`/api/tags`)

const services = {
  fetchMediaByTerm,
  getAllTags,
}

export default services
